export const DECISION_PROCESSING_MS = 10_000;

export const DECISION_RING_CIRCUMFERENCE = 327;

export const decisionSteps = [
  {
    label: 'Leser dokumenterte opplysninger fra virksomhetslommeboken',
    completesAt: 1_300,
  },
  {
    label: 'Kontrollerer virksomhetsopplysninger og dokumentasjon',
    completesAt: 3_200,
  },
  {
    label: 'Verifiserer støttehistorikk og statsstøtteregler',
    completesAt: 5_600,
  },
  {
    label: 'Vurderer prosjekt, budsjett og kommunesamarbeid',
    completesAt: 8_400,
  },
  {
    label: 'Fatter vedtak og klargjør utbetaling',
    completesAt: 10_000,
  },
] as const;

export function elapsedSince(timestamp?: string): number {
  if (!timestamp) return 0;
  const startedAt = Date.parse(timestamp);
  return Number.isFinite(startedAt) ? Math.max(0, Date.now() - startedAt) : 0;
}

export function completedDecisionSteps(submittedAt?: string): number {
  const elapsed = elapsedSince(submittedAt);
  return decisionSteps.filter((step) => elapsed >= step.completesAt).length;
}
